import React from "react";
import { useSelector } from "react-redux";
import { selectEntitiesByFilters } from "../../../../shared/store/views/entityView";
import { bgtDashboardCountersFilters } from "../../../../shared/utils/entitiesFiltersUtils";
import { counterWidgetLayoutType } from "../../../../shared/enums/counterWidgetLayoutType";
import { getObjectByKey } from "../../../../shared/utils/utils";
import Popup from "../../../../shared/components/ui/popup/Popup";
import ContentsPopup from "../../../../shared/components/ui/popup/contentPopup/ContentPopup";
import NavigateLink from "../../../../shared/components/features/navigateLink/navigateLink";
import iconsList from "../../../../shared/components/ui/icons/iconsList";
import bgtPopupLogo from "../../../../assests/bgt/bgtPopupLogo.png";
import classes from "./BgtPopup.module.css";
import CounterWidget from "../../../../shared/components/widget/counterWidget/CounterWidget";

const BgtPopup = ({ onClose }) => {

    const { texts } = useSelector(state => state.translate);
    const { platforms } = useSelector(state => state.uiData);
    const bgt = getObjectByKey("bgt", platforms);
    const counterEntities = useSelector((state) => selectEntitiesByFilters(state, bgtDashboardCountersFilters));

    return (
        <Popup close={onClose} title={texts.bgt}  dropClass={classes.BackdropPopupClass}>
            <ContentsPopup className={classes.ContentsPopup} scrollDropClass={classes.BgtScroll}>
                <div className={classes.BgtPopup}>
                <CounterWidget
                    width={360}
                    height={256}
                    color="#19086F"
                    titleColor="#FFF"
                    icon={iconsList.bgt}
                    counters={counterEntities}
                    layoutType={counterWidgetLayoutType.wide}
                    className={classes.BgtCountersWidget}
                    topContent={<img src={bgtPopupLogo} alt={texts.bgt} className={classes.Logo} />}
                />
                <div className={classes.Buttons}>
                    <NavigateLink link={bgt?.link}>
                        <button type="button" className={classes.PrimaryButton}>
                            <p className={classes.PrimaryButtonText}> {texts.bgtManageLearningSpaces}</p>
                        </button>
                    </NavigateLink>
                </div>
                </div>
            </ContentsPopup>
        </Popup>
    );
};

export default BgtPopup;
